import React, { ReactElement, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";

import Alert from "@mui/material/Alert";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";

import { postCheckCoupon } from "redux/handlers/couponHandler";

import { useAppDispatch } from "hooks/reduxHook";

import { ICouponData } from "types/api/couponApiInterface";

import IconSelector from "../images/IconSelector";

const CheckCoupon = ({
 setCouponData
}: {
 setCouponData: (id: number, percent: number) => void;
}): ReactElement => {
 const intl = useIntl();
 const dispatch = useAppDispatch();

 const [code, setCode] = useState<string>("");
 const [coupon, setCoupon] = useState<ICouponData | null>(null);
 const [loading, setLoading] = useState<boolean>(false);
 const [firstCheck, setFirstCheck] = useState<boolean>(false);
 const [discountApplyed, setDiscountApplied] = useState<boolean>(false);

 const handleCheckCoupon = async () => {
  setLoading(true);
  setCoupon(await dispatch(postCheckCoupon(code)));
  setFirstCheck(true);
  setLoading(false);
 };

 const handleApplyDiscount = () => {
  setDiscountApplied(true);
  if (coupon) setCouponData(coupon.id, coupon?.percentage);
 };

 //4IN8ZM
 return discountApplyed ? (
  <Stack direction="row" mt={2} alignItems="center" spacing={2}>
   <IconSelector icon="CheckCircleIcon" props={{ color: "kxOrange", sx: { fontSize: 40 } }} />
   <Typography>
    <FormattedMessage id="coupon.discountApplied" />
   </Typography>
  </Stack>
 ) : (
  <Stack spacing={2} mt={2} border="1px solid lightgray" borderRadius={2} p={2}>
   <Typography variant="subtitle2">
    <FormattedMessage id="coupon.welcomeMessage" />
   </Typography>
   {!coupon && (
    <Stack direction="row" spacing={2}>
     <TextField
      size="small"
      autoComplete="off"
      label={intl.formatMessage({ id: "coupon.couponCode" })}
      InputLabelProps={{ shrink: true }}
      onChange={({ currentTarget }) => setCode(currentTarget.value)}
     />
     <Button onClick={handleCheckCoupon}>
      <FormattedMessage id="coupon.checkCoupon" />
     </Button>
    </Stack>
   )}
   <Stack>
    {loading ? (
     <CircularProgress />
    ) : (
     firstCheck &&
     (coupon ? (
      <Alert severity="success">
       <Typography variant="subtitle2">
        <FormattedMessage
         id="coupon.validCoupon"
         values={{ code: code, percent: coupon.percentage }}
        />
       </Typography>
      </Alert>
     ) : (
      <Alert severity="error">
       <Typography variant="subtitle2">
        <FormattedMessage id="coupon.notValidOrError" />
       </Typography>
      </Alert>
     ))
    )}
   </Stack>
   {firstCheck && coupon && (
    <Stack direction="row" justifyContent="flex-end" alignItems="center">
     <Button onClick={handleApplyDiscount}>
      <FormattedMessage id="coupon.applyDiscount" />
     </Button>
    </Stack>
   )}
  </Stack>
 );
};

export default CheckCoupon;
